import { render, staticRenderFns } from "./sp-testimonial.vue?vue&type=template&id=12aad43c"
import script from "./sp-testimonial.vue?vue&type=script&lang=js"
export * from "./sp-testimonial.vue?vue&type=script&lang=js"
import style0 from "./sp-testimonial.vue?vue&type=style&index=0&id=12aad43c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports